import React from 'react';
import { Icon } from './Icon.js';
export const IconEarphoneRight = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 8V19H17V11L13 10V3H16C18.7614 3 21 5.23858 21 8Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M7.85742 17.4854L10.5664 22H8.23438L6.43359 19H5V17H7.56641L7.85742 17.4854Z", fill: "currentColor", "data-stroke": "none" }),
        React.createElement("path", { d: "M3 21V12H6C7.65685 12 9 13.3431 9 15C9 16.6569 7.65685 18 6 18H3.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconEarphoneRight.js.map